(function() { window.GUID_9c2db207_aea5_433f_b0af_4acd661c9e4b = { getGuid: function() { return "9c2db207-aea5-433f-b0af-4acd661c9e4b"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Shared;
    (function (Shared) {
        class WallSectionLazyLoader {
            static get instance() {
                if (!WallSectionLazyLoader._instance) {
                    WallSectionLazyLoader._instance = new WallSectionLazyLoader();
                }
                return WallSectionLazyLoader._instance;
            }
            get isDebug() {
                return CS.Controls.ControlBase.isStaticDebug;
            }
            constructor() {
                this.items = [];
                this.ids = [];
                this.state = "disposed";
                this.params = null;
            }
            static init(params) {
                const { instance } = WallSectionLazyLoader;
                instance.dispose();
                requestAnimationFrame(() => {
                    if (params) {
                        WallSectionLazyLoader.setParams(params);
                    }
                    instance.init();
                });
            }
            static dispose() {
                const { instance } = WallSectionLazyLoader;
                instance.dispose();
            }
            static setParams(params) {
                const { instance } = WallSectionLazyLoader;
                instance.params = params;
            }
            /**
             * Returns the top and bottom margin to add to the viewport height when checking if an item is in view.
             */
            getRootMargin() {
                const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                // We want to make sure we start loading the item before it is in view
                // by adding the viewport height to the top and bottom root margin.
                return {
                    top: viewportHeight,
                    bottom: viewportHeight,
                };
            }
            log(...args) {
                CS.Helper.log("WallSectionLazyLoader", ...args);
            }
            init() {
                try {
                    if (this.isDebug) {
                        this.log("Initializing...");
                    }
                    this.state = "ready";
                    const selector = ".accordion-container.lazy-load";
                    const $items = CS.DOM.$body.find(`${selector}`);
                    if (!$items.length) {
                        if (this.isDebug) {
                            this.log(`No elements found using selector "${selector}".`);
                            return;
                        }
                    }
                    this.items = [];
                    this.ids = [];
                    $items.each((index, element) => {
                        const accordion = CS.Controls.GetInstance(CS.Controls.Accordion, $(element), true);
                        if (accordion != null) {
                            this.items.push({
                                id: accordion.ContentId,
                                accordion,
                                observer: null,
                                isLoaded: false,
                            });
                            this.ids.push(accordion.ContentId); // To make it faster to check if an item is already loaded
                        }
                    });
                    if (!this.items.length) {
                        if (this.isDebug) {
                            this.log("Unable to get any instance of accordion from JQuery elmeents.", $items);
                            return;
                        }
                    }
                    if (this.isDebug) {
                        this.log(`Found ${this.items.length} sections to lazy load.`);
                    }
                    this.unbindObservers();
                    this.loadItemsInViewport()
                        .then(() => {
                        this.bindObservers();
                    })
                        .catch((error) => {
                        throw error;
                    });
                }
                catch (error) {
                    console.error("Error while initializing", error);
                }
            }
            loadItemsInViewport() {
                return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.isDebug) {
                            this.log("Loading items in viewport...");
                        }
                        if (!this.items.length) {
                            if (this.isDebug) {
                                this.log("No item to load in viewport.");
                            }
                            return resolve();
                        }
                        for (let i = 0; i < this.items.length; i++) {
                            const item = this.items[i];
                            if (item.isLoaded) {
                                continue;
                            }
                            if (this.isPartiallyInView(item)) {
                                yield this.load({ item });
                            }
                        }
                        if (this.isDebug) {
                            this.log("Items in viewport loaded.");
                        }
                        return resolve();
                    }
                    catch (error) {
                        return reject(error);
                    }
                }));
            }
            /**
             * Checks if an item's HTML element is partially in view by checking if the top or bottom edge is within the viewport.
             */
            isPartiallyInView(item) {
                var _a, _b;
                try {
                    if (this.isDebug) {
                        this.log(`Checking if section "${item.id}" is in view...`);
                    }
                    const rootMargin = this.getRootMargin();
                    const $container = item.accordion.$Container;
                    if (!$container.length) {
                        return false;
                    }
                    const rect = $container[0].getBoundingClientRect();
                    const topHeight = 0;
                    const bottomHeight = 0;
                    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                    let adjustedViewportHeight = viewportHeight -
                        (topHeight + bottomHeight) +
                        ((_a = rootMargin === null || rootMargin === void 0 ? void 0 : rootMargin.bottom) !== null && _a !== void 0 ? _a : 0);
                    const top = ((_b = rootMargin === null || rootMargin === void 0 ? void 0 : rootMargin.top) !== null && _b !== void 0 ? _b : 0) * -1;
                    const isTopEdgeVisible = rect.top <= adjustedViewportHeight && rect.top >= top;
                    const isBottomEdgeVisible = rect.bottom >= top && rect.bottom <= adjustedViewportHeight;
                    const isPartiallyVisible = isTopEdgeVisible || isBottomEdgeVisible;
                    if (this.isDebug) {
                        this.log(`Section "${item.id}" is ${isPartiallyVisible ? "" : "not "}in view.`);
                    }
                    return isPartiallyVisible;
                }
                catch (error) {
                    console.error(`Error while checking if section "${item.id}" is in view`, error);
                    return false;
                }
            }
            load(props) {
                return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.isDebug) {
                            this.log(`Loading item "${props.item.id}"...`);
                        }
                        const item = this.items.find((x) => x.id === props.item.id);
                        if (this.state !== "ready") {
                            if (props.loadItemsInViewport) {
                                if (this.isDebug) {
                                    this.log(`Loading item "${item.id}" even though the state is not "ready" because "loadItemsInViewport" is true. State: "${this.state}"`);
                                }
                            }
                            else {
                                if (this.isDebug) {
                                    this.log(`Loading of item "${item.id}" cancelled because the state is not "ready". State: "${this.state}"`);
                                }
                                return resolve();
                            }
                        }
                        this.state = "loading";
                        item.accordion.$Container.addClass("loading");
                        CS.Helper.ShowLoader({
                            id: item.id,
                            $container: () => item.accordion.$Container,
                            position: "append",
                            autoRemoveDelay: null,
                            overContent: false,
                        });
                        item.accordion.ExpandCollapse(true, () => __awaiter(this, void 0, void 0, function* () {
                            var _a;
                            if (this.isDebug) {
                                this.log(`Item "${item.id}" loaded.`);
                            }
                            item.accordion.$Container.removeClass("loading");
                            item.accordion.$Container.addClass("loaded");
                            item.isLoaded = true;
                            CS.Helper.RemoveLoader({
                                id: item.id,
                                $container: item.accordion.$Container,
                            });
                            if (item.observer) {
                                item.observer.disconnect();
                                item.observer = null;
                            }
                            if ((_a = this.params) === null || _a === void 0 ? void 0 : _a.onSectionLoaded) {
                                this.params.onSectionLoaded(item.accordion.$Container);
                            }
                            if (props.loadItemsInViewport) {
                                this.unbindObservers();
                                this.loadItemsInViewport()
                                    .then(() => {
                                    this.state = "ready";
                                    this.bindObservers();
                                    return resolve();
                                })
                                    .catch((error) => {
                                    this.state = "ready";
                                    throw error;
                                });
                            }
                            else {
                                this.state = "ready";
                                return resolve();
                            }
                        }), () => { });
                    }
                    catch (error) {
                        return reject(error);
                    }
                }));
            }
            bindObservers() {
                try {
                    if (this.isDebug) {
                        this.log("Binding observers...");
                    }
                    if (!this.items.length) {
                        if (this.isDebug) {
                            this.log("No items to bind observer on.");
                        }
                        this.dispose();
                        return;
                    }
                    const rootMargin = this.getRootMargin();
                    let boundCount = 0;
                    for (let i = 0; i < this.items.length; i++) {
                        const item = this.items[i];
                        if (item.isLoaded) {
                            if (item.observer) {
                                item.observer.disconnect();
                                item.observer = null;
                            }
                            if (this.isDebug) {
                                this.log(`Item "${item.id}" is already loaded, observer not bound.`);
                            }
                            continue;
                        }
                        item.observer = new IntersectionObserver((entries) => {
                            entries.forEach((entry) => __awaiter(this, void 0, void 0, function* () {
                                if (entry.isIntersecting) {
                                    if (this.state !== "ready") {
                                        return;
                                    }
                                    const indexOfItem = this.ids.indexOf(item.id);
                                    if (indexOfItem !== 0) {
                                        if (this.isDebug) {
                                            this.log(`Item "${item.id}" is in view but it is not the first item, checking if an item before it is not loaded...`);
                                        }
                                        // We only want to load the next unloaded item.
                                        // This is to avoid the case where the user scrolls too fast
                                        // and the observer is triggered for multiple items at the same time.
                                        const firstUnloadItem = this.items.find((x) => !x.isLoaded);
                                        if (this.isDebug) {
                                            if (firstUnloadItem.id !== item.id) {
                                                this.log(`Item "${firstUnloadItem.id}" is not loaded and is before item "${item.id}", loading it instead...`);
                                            }
                                            else {
                                                this.log(`No unloaded item before "${item.id}" found, loading it...`);
                                            }
                                        }
                                        yield this.load({
                                            item: firstUnloadItem,
                                            loadItemsInViewport: true,
                                        });
                                        return;
                                    }
                                    if (this.isDebug) {
                                        this.log(`Item "${item.id}" is in view, loading it...`);
                                    }
                                    yield this.load({ item, loadItemsInViewport: true });
                                    return;
                                }
                            }));
                        }, {
                            root: null,
                            rootMargin: `${rootMargin.top}px 0px ${rootMargin.bottom}px 0px`,
                            threshold: 0,
                        });
                        item.observer.observe(item.accordion.$Container[0]);
                        boundCount++;
                    }
                    if (this.isDebug) {
                        this.log(`${boundCount} observer${boundCount > 1 ? "s" : ""} bound.`);
                    }
                }
                catch (error) {
                    console.error("Error while binding observers", error);
                }
            }
            unbindObservers() {
                try {
                    if (this.isDebug) {
                        this.log("Unbinding observers...");
                    }
                    let unboundCount = 0;
                    if (this.items && this.items.length) {
                        for (let i = 0; i < this.items.length; i++) {
                            const item = this.items[i];
                            if (item.observer) {
                                item.observer.disconnect();
                                item.observer = null;
                                unboundCount++;
                            }
                        }
                    }
                    if (this.isDebug) {
                        this.log(`${unboundCount} observer${unboundCount > 1 ? "s" : ""} unbound.`);
                    }
                }
                catch (error) {
                    console.error("Error while unbinding observers", error);
                }
            }
            dispose() {
                try {
                    if (this.isDebug) {
                        this.log("Disposing...");
                    }
                    if (this.state === "disposed") {
                        if (this.isDebug) {
                            this.log("Already disposed.");
                        }
                        return;
                    }
                    this.unbindObservers();
                    this.items = [];
                    this.ids = [];
                    this.state = "disposed";
                    this.params = null;
                    if (this.isDebug) {
                        this.log("Disposed.");
                    }
                }
                catch (error) {
                    console.error("Error while disposing", error);
                }
            }
        }
        Shared.WallSectionLazyLoader = WallSectionLazyLoader;
    })(Shared = CS.Shared || (CS.Shared = {}));
})(CS || (CS = {}));

//# sourceMappingURL=WallSectionLazyLoader.pre.js.map
